/**
 Events
 openWindow(action):  需要打开新页面
 openDialog(action): 需要打开dialog
 openNone(action): 不打开,直接操作
 openNoneSuccess(action): None方式请求成功回调
 */
import { createAPI } from '@common'
import queryString from 'query-string'
export default {
  props: {
    btnArray: {
      type: Array,
      default: function () {
        return []
      }
    },
    e5namespace: {
      type: String,
      default: 'e5'
    },
    confirmTitleFlag: {
      type: Boolean,
      default: false
    },
    isNeedHub: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      currentAction: null
    }
  },
  computed: {
    preactionIds () {
      return this.$store.state[this.e5namespace].tableSelectedRows
    },
    tableOriginalData () {
      return this.$store.state[this.e5namespace].tableOriginalData
    },
    paginationData: function () {
      return this.$store.state[this.e5namespace].paginationData
    },
    formData: function () {
      return this.$store.state[this.e5namespace].formData
    },
    tableSortColumn: function () {
      return this.$store.state[this.e5namespace].tableSortColumn
    },
    tableType: function () {
      return this.$store.state[this.e5namespace].tableType
    },
    preaction: function () { // 当前操作预处理返回
      return this.$store.state[this.e5namespace].currentPreaction
    },
    metadata: function () {
      return this.$store.state[this.e5namespace].metadata
    },
    ids: function () {
      return this.$store.state[this.e5namespace].ids
    }
  },
  methods: {
    fetchPreaction () {
      return this.$store.dispatch(this.e5namespace + '/FETCH_E5_PREACTION', ...arguments)
    },
    handleAction (action, row, isSingle) {
       this.currentAction = action
       if (action.needConfirm) { // 是否需要打开dialog确认
         this.dialogVisible = true
       } else {
         this.action(this.currentAction, row, isSingle || false)
       }
    },
    dialogClose () {
      this.dialogVisible = false
    },
    dialogConfirm () { // 此dialog关闭由外部控制
      this.action(this.currentAction)
    },
    action (action, row, isSingle) {
      if (action['no-preaction']) {
        this.handleMode(action)
      } else {
        let config = {
          hubConfig: this.isNeedHub,
          params: {
            params: {
              action: action.id,
              ids: []
            }
          }
        }
        if (isSingle) {
          config.params.params.ids.push(this.tableOriginalData.id)
        } else {
          let preactionIds = this.preactionIds
          for (let i = 0, len = preactionIds.length; i < len; i++) {
            config.params.params.ids.push(preactionIds[i].id)
          }
        }
        // 操作预处理
        this.fetchPreaction({config, row}).then(data => {
          if (data.status === 0) {
            this.handleMode(action)
          }
        })
      }
    },
    handleMode (action) {
      // 执行操作成功的回调,需要外部手动触发
      action.actionSuccessCb = () => {
        if (action.needRefresh) { // 操作后处理
          return this.FETCH_POST_E5_LIST_DATA()
        }
      }
      if (action.mode === 'OPEN') {
        window.actionSuccessCb = action.actionSuccessCb // window添加刷新方法 用于其他页面刷新table
        if (action.url.indexOf('?') > -1) {
          action.$params = queryString.parse(action.url.substring(action.url.indexOf('?'))) // 组件扩展参数 由后台action url传过来
          action.url = action.url.substring(0, action.url.indexOf('?'))
        }
        this.$emit('openWindow', action)
        action.actionSuccessCb()
        // this.FETCH_POST_E5_LIST_DATA() // 打开窗口后需要刷新列表
      } else if (action.mode === 'DIALOG') {
        this.$emit('openDialog', action)
      } else if (action.mode === 'NONE') {
        if (action.url && action.url.indexOf('javascript:') > -1) {
          // 由后台数据触发事件
          let eventName = action.url.replace('javascript:', '')
          // 如果none打开方式为javascript:updateOrder并且列表可排序，则走更新排序逻辑
          action.url === 'javascript:updateOrder' && this.$parent.$refs.table && this.$parent.$refs.table.tableSortable
            ? this.$parent.$refs.table && this.$parent.$refs.table.updateOrder()
            : this.$emit(eventName, action, this)
        } else {
          this.$emit('openNone', action, this) // 传出当前组件实例,目前用于外部控制此dialog关闭
          this.openNone(action)
        }
      } else if (action.mode === 'SITU') {
        this.$emit('openSitu', action, this)
      }
    },
    // NONE打开方式
    openNone (action) {
      if (action.url.indexOf('BASE:/') > -1) {
        action.url = action.url.replace('BASE:/', '')
      }
      if (this.preaction && this.preaction.ids) { // 预处理操作存在
        let params = {
          id: this.preaction.ids[0],
          ids: this.preaction.ids,
          column: this.metadata.column
        }
        createAPI(action.url, 'post', { headers: this.preaction.headers, data: params }, { e5namespace: this.e5namespace }).then(resp => {
          if (resp.data.status === 0) {
            this.dialogVisible = false
            this.$emit('openNoneSuccess', action)
            action.actionSuccessCb()
          }
        })
      } else { // 预处理操作不存在
        let params = {
          id: this.ids[0],
          ids: this.ids,
          column: this.metadata.column
        }
        createAPI(action.url, 'post', { data: params }, { e5namespace: this.e5namespace }).then(resp => {
          if (resp.data.status === 0) {
            this.dialogVisible = false
            this.$emit('openNoneSuccess', action)
            action.actionSuccessCb()
          }
        })
      }
    },
    FETCH_GET_E5_CONDITIONS: function () {
      return this.$store.dispatch(this.e5namespace + '/FETCH_GET_E5_CONDITIONS')
    },
    FETCH_GET_E5_LISTS: function () {
      return this.$store.dispatch(this.e5namespace + '/FETCH_GET_E5_LISTS')
    },
    // 更新table的data
    FETCH_POST_E5_LIST_DATA: function () {
      return this.$store.dispatch(this.e5namespace + '/FETCH_POST_E5_LIST_DATA', {
        vconfig: {
          e5namespace: this.e5namespace
        },
        config: {
          data: {
            list: this.tableType.id,
            page: this.paginationData.currentPage,
            count: this.paginationData.pageSize,
            sortby: this.tableSortColumn.prop,
            sortType: this.tableSortColumn.order,
            conditions: this.formData
          }
        }
      })
    }
  }
}
